import { type FC, memo } from 'react';

import useDateTimeFormat, { type UseDateTimeFormatOptions } from 'hooks/useDateTimeFormat';

type DateTimeFormatProps = { value: Parameters<typeof useDateTimeFormat>[0] } & UseDateTimeFormatOptions;

const DateTimeFormat: FC<DateTimeFormatProps> = ({ value, ...props }: DateTimeFormatProps) => {
  return useDateTimeFormat(value, props);
};

export default memo(DateTimeFormat);
